import { call, select } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'

export default function * requestRemoveUserFromLayout (action) {
  const { layoutId, userId } = action.payload

  try {
    yield call(apiAction, 'RemoveUserFromHomeLayout', {
      layoutId,
      userId
    })
  } catch (error) {
    if (error.code === 507) {
      const state = yield select()

      try {
        yield call(sweetalert, {
          type: 'info',
          text: state.kanbo.locale.messages['DESK_REMOVE_LAST_OWNER_ERROR']
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
